import type { ReactNode } from 'react'

import SeeAll from '@space-core/components/seeAll'
import { useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export type SeeAllProps = {
  path: string
  count: number
  isSales: boolean
}

export type SectionProps = {
  title?: string
  children: ReactNode
  className?: string
  seeAll?: SeeAllProps
  requestTryAgain?: boolean
  subtitle?: string
  textButton?: string
}

const Section = ({ title, children, className, seeAll }: SectionProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.lg})`)
  const myPurchaseClassName = clsx('_d-flex', {
    '_justify-content-between _align-items-center': !isMobile,
    '_flex-column _align-items-start _justify-content-start': isMobile
  })

  const seeAllClassName = clsx({ '_align-self-start': isMobile })

  return (
    <section className={className} data-test='section-component'>
      <header className='_d-flex _justify-content-between _align-items-center _mb-4'>
        <div className={myPurchaseClassName}>
          {title && (
            <h2
              className='_font-weight-bold _text-gray-900 _text-3 _mb-0'
              data-test='section-title'>
              {title}
            </h2>
          )}
        </div>

        {seeAll && (
          <SeeAll
            className={seeAllClassName}
            text={t(seeAll.isSales ? 'products.show_all_qtd' : 'general.show_all_qtd', {
              count: seeAll.count
            })}
            onClick={() => navigate(seeAll.path)}
          />
        )}
      </header>

      {children}
    </section>
  )
}

export default Section
